import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { GoogleMapsAPIWrapper, GoogleMapsScriptProtocol, MouseEvent  } from '@agm/core';
import {FormBuilder, FormGroup, Validators, FormControl, AbstractControl} from '@angular/forms';

declare const google: any;

@Component({
  selector: 'app-geo-component',
  templateUrl: './geo-component.component.html',
  styleUrls: ['./geo-component.component.css']
})
export class GeoComponentComponent implements OnInit {
  lat = 20.536888;
  lng = -100.814828;
  zoom = 18;
  public marcador: marker;
  markers: marker[] = [];
  public mapa = null;
  search: FormGroup;

  @Output() coords = new EventEmitter();

  constructor(
    private fb: FormBuilder
  ) { 
    this.search = this.fb.group({
      buscando: ['', [Validators.required]]
    });
  }

  ngOnInit() {
  }

  changeZoom(zoom) {
    this.zoom = zoom;
  }

  onMapReady(map) {
    this.mapa = map;
   }

   launchCoords(lat, lng) {
    this.coords.emit({lat, lng});
   }

   markerDragEnd(m: marker, $event: any) {
    console.log('dragEnd', m, $event);
    this.markers[0] = {
      lat: $event.coords.lat,
      lng: $event.coords.lng,
      draggable: true
    };
    this.lat = $event.coords.lat;
    this.lng = $event.coords.lng;
    console.log(this.lat);
    this.launchCoords(this.lat, this.lng);
  }

  mapClicked($event: MouseEvent) {
    console.log($event);
    console.log($event.coords.lat);
    console.log($event.coords.lng);
    this.markers[0] = {
      lat: $event.coords.lat,
      lng: $event.coords.lng,
      draggable: true
    };
    this.lat = $event.coords.lat;
    this.lng = $event.coords.lng;
    this.launchCoords(this.lat, this.lng);
  }

  resetMap(){
    this.markers = [] ;
    this.launchCoords(null, null);
  }

  searchLocation(){
    console.log('Buscando in map');
    const busqueda = this.search.get('buscando').value;
    const geocoder = new google.maps.Geocoder();
    if (busqueda === '' || busqueda === null ) {
  
    }else{
      geocoder.geocode({address: busqueda}, (results, status) => {
        if (status === google.maps.GeocoderStatus.OK) {
         // console.log(results[0].geometry.location.lat());
          this.lat = results[0].geometry.location.lat();
          this.lng = results[0].geometry.location.lng();
        }
      });
    }

  }



}

interface marker {
  lat: number;
  lng: number;
  draggable: boolean;
  }